import { render, staticRenderFns } from "./kr-calculator.vue?vue&type=template&id=c2917b10&scoped=true&"
import script from "./kr-calculator.vue?vue&type=script&lang=js&"
export * from "./kr-calculator.vue?vue&type=script&lang=js&"
import style0 from "./kr-calculator.vue?vue&type=style&index=0&id=c2917b10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2917b10",
  null
  
)

export default component.exports